/**
 * Monthly subscale trend chart — one line per subscale, system-wide averages.
 */

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import { SUBSCALE_META } from '@/lib/dashboard/types';
import type { MonthlySubscalePoint } from '@/lib/dashboard/aggregations';

export function SubscaleTrendChart({ data }: { data: MonthlySubscalePoint[] }) {
  if (data.length === 0) {
    return (
      <div className="rounded-xl border bg-card p-5 text-center text-sm text-muted-foreground">
        Not enough data for subscale trends.
      </div>
    );
  }

  return (
    <div className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-muted-foreground uppercase tracking-wide">
        Monthly Subscale Trends (System-wide)
      </h3>
      <ResponsiveContainer width="100%" height={380}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="month" tick={{ fontSize: 11 }} />
          <YAxis domain={[0, 7]} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <ReferenceLine
            y={5}
            stroke="#8AB74A"
            strokeDasharray="4 4"
            label={{ value: 'Good', fill: '#8AB74A', fontSize: 11 }}
          />
          {SUBSCALE_META.map((s) => (
            <Line
              key={s.id}
              type="monotone"
              dataKey={s.id}
              name={s.name}
              stroke={s.color}
              strokeWidth={2}
              dot={{ r: 4 }}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
